import script from "./ElementProgressTableColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./ElementProgressTableColumn.vue?vue&type=script&setup=true&lang=js"

import "./ElementProgressTableColumn.vue?vue&type=style&index=0&id=106ca5b8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-106ca5b8"]])

export default __exports__